import React, {useEffect, useMemo, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import campaignLinkService from '../../../services/campaignLinkService';
import promoterService from '../../../services/promoterService';
import partnerService from '../../../services/partnerService';
import {myCampaignLinkTableColumns, userCampaignLinkTableColumns} from '../../../components/molecules/Table/columns';
import TableComponent from '../../../components/molecules/Table/component';
import {createCampaignLinkTableChangeHandler, ListCampaignLinkFilters, useIsMobile} from "../../../utils/helpers";
import {mobileRenderers} from "../../../components/molecules/Table/tableMobileRenderers";

interface CampaignLinkListPageProps {
    type?: 'my-campaign-links' | 'promoter-campaign-links' | 'partner-campaign-links';
    title?: string;
}

const CampaignLinkListPage: React.FC<CampaignLinkListPageProps> = ({type, title}) => {
    const [campaignLinkList, setCampaignLinkList] = useState<any[]>([]);
    const [selectedCampaignLink, setSelectedCampaignLink] = useState<any | null>(null);
    const tableColumns = type === 'my-campaign-links' ? myCampaignLinkTableColumns : userCampaignLinkTableColumns;
    const variant = type === 'my-campaign-links' ? 'myCampaignLinks' : 'userCampaignLinks';
    const {id} = useParams<{ id: string }>();
    const navigate = useNavigate();
    const isMobile = useIsMobile();

    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState<ListCampaignLinkFilters>({
        isActive: undefined,
        search: '',
        sortBy: 'clickCounter',
        sortDirection: 'desc',
    });

    const onTableChange = useMemo(() =>
        createCampaignLinkTableChangeHandler(filters, setFilters), [filters]
    );

    useEffect(() => {
        const fetchCampaignLinks = async () => {
            setLoading(true);
            try {
                let data;
                if (type === 'my-campaign-links') {
                    data = await campaignLinkService.getCampaignLinks(filters);
                } else if (type === 'promoter-campaign-links') {
                    data = await promoterService.getPromoterCampaignLinks(id as string, filters);
                } else {
                    data = await partnerService.getPartnerCampaignLinks(id as string, filters);
                }
                setCampaignLinkList(data);
            } catch (error) {
                console.error('Error fetching campaign links:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchCampaignLinks();
    }, [filters]);

    const handleRowClick = (record: any) => {
        setSelectedCampaignLink(record);
    };

    if (selectedCampaignLink) navigate(`/campaign-links/${selectedCampaignLink?._id}`);

    return (
        <div style={{position: 'relative', paddingTop: isMobile ? '40px' : '20px'}}>
            <TableComponent columns={tableColumns} title={title} data={campaignLinkList || []}
                            onRowClick={handleRowClick} loading={loading} onChange={onTableChange} isMobile={isMobile}
                            mobileVariant={variant} mobileRenderers={mobileRenderers} rowKey={(row) => row._id}/>
        </div>
    );
};

export default CampaignLinkListPage;
